import { defineNuxtRouteMiddleware, navigateTo, useRuntimeConfig } from '#imports';
import { handleRedirect } from '@seb-platform/shared/middleware/redirect';

export default defineNuxtRouteMiddleware((to, from) => {
  const config = useRuntimeConfig();
  const { path, query, hash } = to;

  // In the exported header/footer, we want to actually navigate to any changed path instead of using client navigation
  if (config.public.IS_HEADER_FOOTER_EXPORT) {
    const pathHasChanged = from.path !== path;
    if (import.meta.client && pathHasChanged) {
      return navigateTo(to.fullPath, { external: true });
    }
    // We don't want the middleware to run in the header/footer export
    return;
  }

  return handleRedirect({ path, query, hash });
});
